// Module
var code = `<a data-channel="ROUTE" data-page-id="home" data-end-route=true
  class="mb-2 flex h-20 items-end justify-start rounded-md bg-blue-600 p-4 md:h-40"
  href="/"
>
  <div class="w-32 text-white md:w-40" data-slot="acme-logo"></div>
</a>
<div
  class="flex grow flex-row justify-between space-x-2 md:flex-col md:space-x-0 md:space-y-2"
>
  <div data-slot="nav-links" class="contents"></div>
  <button
    type="button"
    id="quick-search-open"
    data-event-type="acmeSearch"
    data-btn-type="open-quick-search"
    title="Quick search ({{kbdHint}})"
    class="flex h-[48px] grow items-center justify-center gap-2 rounded-md bg-gray-50 p-3 text-sm font-medium hover:bg-sky-100 hover:text-blue-600 md:flex-none md:justify-start md:p-2 md:px-3"
  >
    {{svgMagnifyingGlass}}
    <span class="hidden md:block">Search</span>
    <span class="qs-kbd-hint hidden md:block">{{kbdHint}}</span>
  </button>
  <div class="hidden h-auto w-full grow rounded-md bg-gray-50 md:block"></div>
  <form>
    <button
      type="button"
      data-event-type="signOut"
      id="sign-out"
      class="flex h-[48px] w-full grow items-center justify-center gap-2 rounded-md bg-gray-50 p-3 text-sm font-medium hover:bg-sky-100 hover:text-blue-600 md:flex-none md:justify-start md:p-2 md:px-3"
    >
      {{svgPower}}
      <div class="hidden md:block">{{signOutText}}</div>
    </button>
  </form>
</div>
`;
// Exports
module.exports = code;